import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { IFilterDataItem } from "components/Filters/filtersOptions";

interface IPreferredCondition {
  id: string;
  description: string;
}

interface IPreferredConditionsFilters {
  raceTypes: IFilterDataItem[];
  claimingPriceTypes: IFilterDataItem[];
  distanceTypes: IFilterDataItem[];
}

const transformDataToIFilterDataItems = (
  defaultArray: Extract<
    racehorse360.IRaceDistance,
    racehorse360.IClaimingPrice
  >[]
): IFilterDataItem[] => {
  const resultArray: IFilterDataItem[] = [];

  defaultArray.forEach((defaultArrayItem: IPreferredCondition) => {
    const includedItemInResult = resultArray.some(
      (item: IFilterDataItem) => item.value === defaultArrayItem.id
    );

    if (!includedItemInResult) {
      resultArray.push({
        label: defaultArrayItem.description,
        value: defaultArrayItem.id
      });
    }
  });

  return resultArray;
};

export const getPreferredConditionsFilters = (
  data: racehorse360.IRegionPreferredConditions
): IPreferredConditionsFilters => {
  let raceTypes: IFilterDataItem[] = [];
  let distanceTypes: IFilterDataItem[] = [];
  let claimingPriceTypes: IFilterDataItem[] = [];

  if (data) {
    const unitedRaceTypesIds = [];
    const unitedRaceTypesLabels = [];

    const preliminaryRaceTypes = data.raceTypes
      .filter((item: racehorse360.RaceType) => {
        const itemName = item.name.toLowerCase();
        if (itemName === "hcp" || itemName === "ost" || itemName === "stk") {
          unitedRaceTypesIds.push(item.id);
          unitedRaceTypesLabels.push(item.name);
        }

        return itemName !== "hcp" && itemName !== "ost" && itemName !== "stk";
      })
      .map((item: racehorse360.RaceType) => ({
        label: item.name,
        value: item.id
      }));

    const unitedRaceType: IFilterDataItem = {
      label: unitedRaceTypesLabels.sort().join("/"),
      value: unitedRaceTypesIds.join("/")
    };

    raceTypes = [unitedRaceType, ...preliminaryRaceTypes].sort((rt1, rt2) =>
      rt1.label.localeCompare(rt2.label)
    );

    claimingPriceTypes = data.raceTypeClaimingPrices
      .flatMap(rtcp => rtcp.claimingPrices)
      .sort(
        (cp1, cp2) => cp1.minPrice - cp2.minPrice || cp2.maxPrice - cp2.maxPrice
      )
      .reduce((acc, cur) => {
        if (!acc.some(item => item.id === cur.id)) {
          acc.push(cur);
        }
        return acc;
      }, [])
      .map(
        cp =>
          ({
            value: cp.id,
            label: cp.description.toLowerCase().replace("to", "-")
          } as IFilterDataItem)
      );

    const distanceTypesForAnySurface = data.surfaceRaceDistances
      .flatMap(srd => srd.raceDistances)
      .sort((rd1, rd2) => rd1.distance - rd2.distance);
    distanceTypes = transformDataToIFilterDataItems([
      ...new Set(distanceTypesForAnySurface)
    ]);
  }

  return {
    raceTypes,
    claimingPriceTypes,
    distanceTypes
  };
};
